module.exports = __webpack_public_path__ + "static/media/image-resize-square.83d9ac32.svg";